import React from "react";
import styles from "./viewTreatment.module.scss";
import { signedLockedAccess } from "../../../utils";
import { useSelector } from "react-redux";
import editIcon from "../../../static/images/edit-icon-blue.png";
import { EDIT } from "../../../constants";
import { usePermissions } from "../../../hooks/usePermissions";
import { PERMISSIONS } from "../../../constants/permissions";

export const TreatmentEditIcon = ({ editable, handleEdit }) => {
  const assessmentDetails = useSelector((state) => state.patient.detailAssessment);
  const { hasPermission } = usePermissions();

  return (
    !editable &&
    signedLockedAccess(assessmentDetails?.assessmentStage) && (
      <div className={`${styles.edit_icon}`}>
        <button className={`float-sm-right ${styles.tab_edit} handleEdit`} onClick={handleEdit} disabled={!hasPermission(PERMISSIONS.TREATMENT_EDIT)}>
          <img src={editIcon} alt="edit" />
          {EDIT}
        </button>
      </div>
    )
  );
};
